<template>
  <div class="d-flex align-center justify-space-between">
    <SearchTextField v-model="searchQuery"
                    :disabled="roomNotificationsPending"
                    :tooltipText="$t('project.project-settings.ProjectSettingsNotifications.searchPlaceholder')"
                    @keydown.enter="onEnterDown"
                    @clear="onClearClick"
    />

    <AppDownloadFile :link="exportNotificationsLink">
      <template #default="{submitForm}">
        <app-button
          data-locator="export-button"
          @click="exportNotifications(submitForm)"
        >
          <app-material-icon name="upload" color="icon-inverted" />
          {{ $t('project.project-settings.ProjectSettingsNotifications.export') }}
        </app-button>
      </template>
    </AppDownloadFile>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapState, mapGetters, useStore } from 'vuex'

  import AppDownloadFile from '@/common/AppDownloadFile.vue'
  import { useSearch } from '@/common/search/useSearch'
  import SearchTextField from '@/common/SearchTextField.vue'
  import { SET_ROOM_NOTIFICATIONS_SEARCH_QUERY } from '@/store/modules/room/mutation_types'

  const SEARCH_QUERY_DEBOUNCE_TIMER = 2000

  export default {
    name: 'ProjectSettingsNotificationsTopBar',
    components: {
      AppDownloadFile,
      SearchTextField,
    },
    props: {
      mnemo: {
        type: String,
        required: true,
      },
    },
    setup () {
      const store = useStore()
      const { searchQuery } = useSearch(
        (value) => { store.commit('room/' + SET_ROOM_NOTIFICATIONS_SEARCH_QUERY, value) },
        SEARCH_QUERY_DEBOUNCE_TIMER,
        store.state.room.roomNotificationsSearchQuery,
      )
      return {
        searchQuery,
      }
    },
    computed: {
      ...mapState('room', ['roomNotificationsPending']),
      ...mapGetters('room', ['getNotificationsParams']),
      exportNotificationsLink () {
        return axios.getUri({
          url: `${import.meta.env.VUE_APP_API_URL}/room/${this.mnemo}/downloads/notifications-excel`,
          params: this.getNotificationsParams,
        })
      },
    },
    methods: {
      ...mapMutations('room', [SET_ROOM_NOTIFICATIONS_SEARCH_QUERY]),
      onEnterDown (event) {
        this.SET_ROOM_NOTIFICATIONS_SEARCH_QUERY(event.target.value)
      },
      onClearClick () {
        this.SET_ROOM_NOTIFICATIONS_SEARCH_QUERY('')
      },
      exportNotifications (submitFormCallback) {
        submitFormCallback()
      },
    },
  }
</script>
